
import {defineComponent, PropType} from "vue";

import { Provider } from "@/utils/providers/provider";

const PROVIDERS = {
  metamask: "Metamask",
  walletConnect: "WalletConnect",
  // walletLink: "WalletLink",
};

type ComponentData = {
  isLoading: boolean;
  loadingProviderName: string;
};

export default defineComponent({
  props: {
    params: {
      type: Object as PropType<ParamsNetwork>,
      required: true,
    },
    uncancellable: {
      type: Boolean,
      default: false,
    },
  },

  data(): ComponentData {
    return {
      isLoading: false,
      loadingProviderName: "",
    };
  },

  computed: {
    providersList(): string[] {
      return Object.keys(PROVIDERS);
    },
  },

  created() {
    document.addEventListener("keydown", this.onKeyDown);
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown);
  },

  methods: {
    onKeyDown(e: KeyboardEvent) {
      if (e.keyCode === 27) {
        this.close();
      }
    },
    close() {
      if (this.uncancellable) return;
      if (this.isLoading) return;
      this.$emit("cancel");
    },
    async onProviderClick(providerName: string): Promise<void> {
      if (this.isLoading) return;

      this.isLoading = true;
      this.loadingProviderName = providerName;

      const providerComponentName: string =
        PROVIDERS[providerName as keyof typeof PROVIDERS];
      const ProviderComponent = await import(
        `@/utils/providers/${providerName}/index`
      );

      try {
        const provider = new ProviderComponent[
          providerComponentName
        ]() as Provider;

        const result = await provider.connect(this.params);

        this.isLoading = false;

        if (!result) {
          return;
        }

        this.$emit("wallet-connected", provider);
      } catch (e: any) {
        const message = this.$t(e.message) ? this.$t(e.message) : e.message;
        console.error(message);
        alert(message);
        this.isLoading = false;
      }
    },
  },
});
